import { useEffect, useState } from "react";
import { api, errorMsg } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const vacio = { usuario: "", password: "", nombre: "", rol_id: "", telefono: "" };

export const UsuarioFormDialog = ({ open, usuario, onOpenChange, onSaved }) => {
  const [form, setForm] = useState(vacio);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (!open) return;
    api.get("/roles").then((r) => setRoles(r.data)).catch(() => {});
    setForm(usuario ? { usuario: usuario.usuario, password: "", nombre: usuario.nombre || "",
      rol_id: usuario.rol_id || "", telefono: usuario.telefono || "" } : vacio);
  }, [open, usuario]);

  const guardar = async () => {
    try {
      if (usuario) {
        const payload = { nombre: form.nombre, rol_id: form.rol_id || "", telefono: form.telefono };
        if (form.password) payload.password = form.password;
        await api.patch(`/usuarios/${usuario.id}`, payload);
        toast.success("Usuario actualizado");
      } else {
        await api.post("/usuarios", { ...form, rol_id: form.rol_id || null });
        toast.success("Usuario creado");
      }
      onOpenChange(false); onSaved();
    } catch (e) { toast.error(errorMsg(e)); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white">
        <DialogHeader><DialogTitle>{usuario ? "Editar usuario" : "Nuevo usuario"}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1"><Label>Usuario *</Label>
            <Input data-testid="usuario-username-input" value={form.usuario} disabled={!!usuario}
              autoComplete="off" name="nuevo-usuario-nombre"
              onChange={(e) => setForm({ ...form, usuario: e.target.value })} /></div>
          <div className="space-y-1"><Label>Nombre</Label>
            <Input data-testid="usuario-nombre-input" value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} /></div>
          <div className="space-y-1"><Label>Teléfono (WhatsApp)</Label>
            <Input data-testid="usuario-telefono-input" value={form.telefono}
              inputMode="numeric" autoComplete="off" name="telefono-wa" maxLength={9}
              onChange={(e) => {
                const d = e.target.value.replace(/\D/g, "").slice(0, 8);
                setForm({ ...form, telefono: d.length > 4 ? `${d.slice(0, 4)}-${d.slice(4)}` : d });
              }} placeholder="Ej: 6021-2382" />
            <p className="text-xs text-muted-foreground">8 dígitos (Costa Rica). A este WhatsApp llegan los códigos de recuperación de contraseña.</p></div>
          <div className="space-y-1">
            <Label>{usuario ? "Nueva contraseña (dejar vacío para no cambiar)" : "Contraseña inicial *"}</Label>
            <Input data-testid="usuario-password-input" type="password" value={form.password}
              autoComplete="new-password" name="nueva-clave"
              onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Mínimo 6 caracteres" /></div>
          <div className="space-y-1"><Label>Rol</Label>
            <Select value={form.rol_id || "ninguno"}
              onValueChange={(v) => setForm({ ...form, rol_id: v === "ninguno" ? "" : v })}>
              <SelectTrigger data-testid="usuario-rolid-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="ninguno">Sin rol (sin acceso a módulos)</SelectItem>
                {roles.map((r) => (
                  <SelectItem key={r.id} value={r.id}>
                    {r.nombre}{r.es_admin ? " (acceso total)" : ""}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <p className="text-xs text-muted-foreground">Define qué módulos y acciones puede usar. El rol Administrador da acceso total.</p></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button data-testid="guardar-usuario-btn" onClick={guardar}
            disabled={!form.usuario || (!usuario && form.password.length < 6) ||
              (form.telefono !== "" && form.telefono.replace(/\D/g, "").length !== 8)}>Guardar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
